import { RENEWAL_SOON_DAYS } from '../config';
import { daysUntil, formatIsoDate, renewalStatus, todayIso } from '../lib/dates';

const LABEL = { overdue: 'Overdue', soon: 'Due soon', ok: '' } as const;

export function RenewalBadge({ date }: { date: string }) {
  const today = todayIso();
  const status = renewalStatus(date, today, RENEWAL_SOON_DAYS);
  const days = daysUntil(date, today);
  const hint =
    days === 0 ? 'today' : days > 0 ? `in ${days} day${days === 1 ? '' : 's'}` : `${-days} day${days === -1 ? '' : 's'} ago`;

  return (
    <span className={`renewal renewal--${status}`} title={hint}>
      <time dateTime={date}>{formatIsoDate(date)}</time>
      {status !== 'ok' && <span className="renewal__label">{LABEL[status]}</span>}
    </span>
  );
}
